module.exports = __webpack_public_path__ + "img/polaroid-2-fill.7d0df64a.svg";